var Webflow = Webflow || [];
Webflow.push(function () {
  var count = $(".main-product-img").length;

  if (count > 1) {
    var $pdpSlider = $(".pdp-slider").flickity({
      fade: true,
      pageDots: false,
      prevNextButtons: false,
      wrapAround: true,
      draggable: true,
      imagesLoaded: true,
      contain: true,
      cellAlign: "left",
    });
    $(".button-row").removeClass("hide");
    // Reinit after load
    // setTimeout(function(){
    // 	$pdpSlider.flickity('resize');
    // }, 1000);
    // Flickity instance
    var flkty = $pdpSlider.data("flickity");
    // elements
    var $cellButtonGroup = $(".button-group--cells");
    var $cellButtons = $cellButtonGroup.find(".dot");
    // update selected cellButtons
    $pdpSlider.on("select.flickity", function () {
      $cellButtons.filter(".is-selected").removeClass("is-selected");
      $cellButtons.eq(flkty.selectedIndex).addClass("is-selected");
    });
    // select cell on button click
    $cellButtonGroup.on("click touch", ".dot", function () {
      var index = $(this).index();
      $pdpSlider.flickity("select", index);
    });
    // previous
    $(".button--previous").on("click", function () {
      $pdpSlider.flickity("previous");
    });
    // next
    $(".button--next").on("click", function () {
      $pdpSlider.flickity("next");
    });
  } else {
    $(".pdp-slider.multi-image-slider").addClass("slider-disabled");
  }

  var $otherOptionsSlider = $(
    ".large-slideshow, .description-slideshow"
  ).flickity({
    fade: true,
    pageDots: true,
    prevNextButtons: false,
    autoPlay: 6000,
  });

  //  Lower Slider
  var otherOptions = {
    fade: true,
    pageDots: false,
    prevNextButtons: false,
    freeScroll: false,
  };

  if (matchMedia("screen and (max-width: 768px)").matches) {
    otherOptions.fade = false;
    otherOptions.freeScroll = true;
    otherOptions.contain = true;
  }

  $(window).on("resize", function () {
    if (matchMedia("screen and (max-width: 768px)").matches) {
      otherOptions.fade = false;
      otherOptions.freeScroll = true;
      otherOptions.contain = true;
    }
  });

  var $otherOptionsSlider = $(".other-options-slider").flickity(otherOptions);

  // Lower Slider Bullets
  var options = {
    asNavFor: ".other-options-slider",
    pageDots: false,
    prevNextButtons: false,
    contain: true,
    draggable: false,
  };

  $otherOptionsSlider.flickity("resize");

  setTimeout(function () {
    $(".flickity-enabled").flickity("resize");
  }, 1000);

  if (matchMedia("screen and (max-width: 768px)").matches) {
    options.contain = false;
  }

  $(window).on("resize", function () {
    // remove contain at 768px
    if (matchMedia("screen and (max-width: 768px)").matches) {
      options.contain = false;
    }
  });

  // PDP Pages
  // Height & Sizes
  var $productPage = $(".size-guide");
  if ($productPage.length) {
    var offset = $(".wrapper").offset();
    $("a.find-your-size-link").on("click", function () {
      $(".size-guide-wrap").addClass("reveal");
      if (matchMedia("screen and (min-width: 768px)").matches) {
        $(".size-guide").css("padding-left", offset.left);
      }
    });
  }
  $("a.close-size-guide").on("click", function () {
    $(".size-guide-wrap").removeClass("reveal");
    setTimeout(function () {
      $(".standover-guide").removeClass("show");
    }, 1000);
  });
  $("a.shipping-assembly").on("click", function () {
    $(".shipping-assembly-wrapper").addClass("reveal");
    $(".pdp-slider a").css("pointer-events", "none");
  });
  $("a.help").on("click", function () {
    $(".help-wrapper").addClass("reveal");
    $(".pdp-slider a").css("pointer-events", "none");
  });
  $("a.close-help").on("click", function () {
    $(".help-wrapper").removeClass("reveal");
    $(".pdp-slider a").css("pointer-events", "auto");
  });
  $("a.close-shipping").on("click", function () {
    $(".shipping-assembly-wrapper").removeClass("reveal");
    $(".pdp-slider a").css("pointer-events", "auto");
  });
  $(document).mouseup(function (e) {
    var container = $(
      ".shipping-assembly-wrapper, .help-wrapper, .size-guide-wrap, .reviews-wrapper"
    );
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      container.removeClass("reveal");
      $(".pdp-slider a").css("pointer-events", "auto");
    }
  });
  $(document).mouseup(function (e) {
    var modalContainer = $(".junip-modal-container");
    if (
      !modalContainer.is(e.target) &&
      modalContainer.has(e.target).length === 0
    ) {
      $(".junip-close").trigger("click");
    }
  });
  $(window).on("resize", function () {
    var offset = $(".wrapper").offset();
    if (matchMedia("screen and (min-width: 768px)").matches) {
      $(".size-guide").css("padding-left", offset.left);
    }
  });

  // Chooze your Size
  // Show or hide cm / inches
  $(".height-button").on("click", function () {
    if ($(this).hasClass("selected")) {
    } else {
      $(this).addClass("selected").siblings().removeClass("selected");
      $(".height-wrapper.show").removeClass("show").siblings().addClass("show");
    }
  });

  $(".select-field.cm-select").change(function () {
    getCMSize();
  });

  function getCMSize() {
    var cmHeight = $(".select-field.cm-select").val();
    $(".height-rec").addClass("show");
    if (+cmHeight <= 163) {
      $(".table-row").siblings().removeClass("selected-size");
      $(".table-row:nth-child(2)").addClass("selected-size");
      $(".frame-select-option-wrapper:nth-child(1) input").trigger("click");
    } else if (+cmHeight >= 164 && +cmHeight <= 173) {
      $(".table-row").siblings().removeClass("selected-size");
      $(".table-row:nth-child(3)").addClass("selected-size");
      $(".frame-select-option-wrapper:nth-child(2) input").trigger("click");
    } else if (+cmHeight >= 174 && +cmHeight <= 180) {
      $(".table-row").siblings().removeClass("selected-size");
      $(".table-row:nth-child(4)").addClass("selected-size");
      $(".frame-select-option-wrapper:nth-child(3) input").trigger("click");
    } else if (+cmHeight >= 181) {
      $(".table-row").siblings().removeClass("selected-size");
      $(".table-row:nth-child(5)").addClass("selected-size");
      $(".frame-select-option-wrapper:nth-child(4) input").trigger("click");
    }
  }

  // Inches Reveal
  $("select#Inches").prop("disabled", "disabled");
  $("select#Feet").change(function () {
    if ($("select#Inches").prop("disabled") == false) {
      getSize();
    } else {
      $("select#Inches").prop("disabled", false);
    }
  });
  $("select#Inches").change(getSize);

  var xsSize = $(".XS .rider-height").text();
  var xsMax = xsSize.substr(xsSize.length - 6).split("c");
  var xsMaxInch = xsMax[0] / 2.54;
  var smallSize = $(".S .rider-height").text();
  var smallSplitSize = smallSize
    .substr(smallSize.length - 12)
    .replace(/.{0,3}$/, "")
    .split(" - ");
  var smallMinInch = smallSplitSize[0] / 2.54;
  var smallMaxInch = smallSplitSize[1] / 2.54 - 1.968503937;
  var medSize = $(".M .rider-height").text();
  var medSplitSize = medSize
    .substr(medSize.length - 12)
    .replace(/.{0,3}$/, "")
    .split(" - ");
  var medMinInch = medSplitSize[0] / 2.54;
  var medMaxInch = medSplitSize[1] / 2.54;
  var largeSize = $(".L .rider-height").text();
  var largeSplitSize = largeSize
    .substr(largeSize.length - 12)
    .replace(/.{0,3}$/, "")
    .split(" - ");
  var largeMinInch = largeSplitSize[0] / 2.54;

  var rows = $(".not-bike .table-row");
  $(".not-bike .table-row").click(function () {
    var current_row = rows.index(this);
    console.log(current_row);
    var sizeToClick = current_row;
    $(
      ".frame-select-option-wrapper:nth-child(" + sizeToClick + ") input"
    ).trigger("click");
  });

  function getSize() {
    var inchesHeight = $("select#Inches").val();
    var feetHeight = $("select#Feet").val();
    var totalHeight = +feetHeight + +inchesHeight;

    $(".height-rec").addClass("show");
    if ($(".table-row").hasClass("XS")) {
      if (+totalHeight <= xsMaxInch) {
        $(".table-row").siblings().removeClass("selected-size");
        $(".table-row:nth-child(2)").addClass("selected-size");
        $(".frame-select-option-wrapper:nth-child(1) input").trigger("click");
      } else if (+totalHeight >= smallMinInch && +totalHeight <= smallMaxInch) {
        $(".table-row").siblings().removeClass("selected-size");
        $(".table-row:nth-child(3)").addClass("selected-size");
        $(".frame-select-option-wrapper:nth-child(2) input").trigger("click");
      } else if (+totalHeight >= medMinInch && +totalHeight <= medMaxInch) {
        $(".table-row").siblings().removeClass("selected-size");
        $(".table-row:nth-child(4)").addClass("selected-size");
        $(".frame-select-option-wrapper:nth-child(3) input").trigger("click");
      } else if (+totalHeight >= largeMinInch) {
        $(".table-row").siblings().removeClass("selected-size");
        $(".table-row:nth-child(5)").addClass("selected-size");
        $(".frame-select-option-wrapper:nth-child(4) input").trigger("click");
      }
    } else {
      if (+totalHeight <= smallMaxInch) {
        $(".table-row").siblings().removeClass("selected-size");
        $(".table-row:nth-child(2)").addClass("selected-size");
        $(".frame-select-option-wrapper:nth-child(1) input").trigger("click");
      } else if (+totalHeight >= medMinInch && +totalHeight <= medMaxInch) {
        $(".table-row").siblings().removeClass("selected-size");
        $(".table-row:nth-child(3)").addClass("selected-size");
        $(".frame-select-option-wrapper:nth-child(2) input").trigger("click");
      } else if (+totalHeight >= largeMinInch) {
        $(".table-row").siblings().removeClass("selected-size");
        $(".table-row:nth-child(4)").addClass("selected-size");
        $(".frame-select-option-wrapper:nth-child(3) input").trigger("click");
      }
    }
  }

  // Standover Guide
  $(".size-get-started-link").on("click", function () {
    $(".standover-guide").addClass("show");
  });
  $(".close-sizing-chart").on("click", function () {
    $(".standover-guide").removeClass("show");
  });

  // Mobile Specs
  $(".specification").on("click", function () {
    if ($(this).hasClass("reveal")) {
      $(this).removeClass("reveal");
      $(this).find(".icon.arrow-down").removeClass("flip");
      $(this).find(".spec-description").removeClass("reveal");
    } else {
      $(this).addClass("reveal").siblings().removeClass("reveal");
      $(this).siblings().find(".icon.arrow-down").removeClass("flip");
      $(this).siblings().find(".spec-description").removeClass("reveal");
      $(this).find(".icon.arrow-down").addClass("flip");
      $(this).find(".spec-description").addClass("reveal");
    }
  });

  $(".more-color-choice").flickity(options);

  $(".frame-select-option-wrapper input").on("click", function () {
    const variant = $(this).val();
    $(".add-to-cart-button").attr("data-variant", variant);
  });
  
  $(".frame-select-option-wrapper input").on("click", function () {
    const priceElement = $(".price-wrap .price:first");
    if (priceElement.length) {
      const selectedVariantId = $(this).val();
      const variantPrice = $(this).attr('data-variant-price');
      if (variantPrice) {
        priceElement.text(variantPrice);
      }
    }
  });

  $(".frame-select-option-wrapper input").on("click", function () {
    if ($(this).next(".XS").length !== 0) {
      const xsContent = $(".XS .table-column:nth-child(2) .table-text").text();
      $(".height").text("Height: " + xsContent.split("(")[0]);
    } else if ($(this).next(".S").length !== 0) {
      const xsContent = $(".S .table-column:nth-child(2) .table-text").text();
      $(".height").text("Height: " + xsContent.split("(")[0]);
    } else if ($(this).next(".M").length !== 0) {
      const xsContent = $(".M .table-column:nth-child(2) .table-text").text();
      $(".height").text("Height: " + xsContent.split("(")[0]);
    } else if ($(this).next(".L").length !== 0) {
      const xsContent = $(".L .table-column:nth-child(2) .table-text").text();
      $(".height").text("Height: " + xsContent.split("(")[0]);
    }
  });

  $(".product-zoom").magnificPopup({
    type: "image",
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      arrowMarkup:
        '<button title="%title%" type="button" class="tokyo-bike-symbols mfp-arrow-%dir%"></button>',
    },
  });

  // if ($(".color-choice-wrap").hasClass("w--current")) {
  //   const colorTitle = $(".w--current .color-choice").attr("data-color-title");
  //   $(".color-text").text("Color: " + colorTitle);
  // } else {
  //   $(".color-text").text("");
  // }

  // var count = $(".color-choice-wrap").length;
  // if (count > 10) {
  //   $(".color-selections-wrapper").css("max-width", "60%");
  // }

  var optionsLength = $(".frame-section .frame-select-option-wrapper").length;
  setTimeout(function () {
    if (optionsLength < 1) {
      // $('.add-to-cart-button').css('cursor', 'disable');
      // $('.add-to-cart-button').text('Select an Option');
      // $(".frame-select-option-wrapper:first-child").prop("checked", true);
      // $('.frame-select-option-wrapper:first-child').trigger('click');
    }
  }, 1000);

  $(".select-frame-size").on("click", function () {
    if ($(this).hasClass("w--redirected-checked")) {
      // $(this).removeClass("w--redirected-checked");
    } else {
      $(this)
        .addClass("w--redirected-checked")
        .parent()
        .siblings()
        .children()
        .removeClass("w--redirected-checked");
    }
  });

  $(".frame-select-option-wrapper input").on("click", function () {
    if ($(this).parent(".show-add-to-cart").hasClass("show-add-to-cart-text")) {
      $(".add-to-cart-button").text("Add to Cart");
      $("#notify").attr("style", "display: none !important");
      $(".select-size-button").hide();
      $(".add-to-cart-button").show();
    } else if ($(this).parent().hasClass("show-pre-order-text")) {
      $(".add-to-cart-button").text("Pre-Order");
      $("#notify").attr("style", "display: none !important");
      $(".select-size-button").hide();
      $(".add-to-cart-button").show();
    } else if (
      $(this).parent(".show-notify").hasClass("show-add-to-cart-text")
    ) {
      $(".add-to-cart-button").hide();
      $(".select-size-button").hide();
      $("#notify").attr("style", "display: block !important");
    }
  });

  $(".add-to-cart-button").on("click", function () {
    variantId = $(this).attr("data-variant");
    CartJS.addItem(
      variantId,
      1,
      {},
      {
        success: function (data, textStatus, jqXHR) {
          var productTitle = $(".added-to-cart .info-bar-link").text();
          $(".added-to-cart p.info-bar-link").text(productTitle);
          $(".added-to-cart").addClass("show-add");
        },

        error: function (jqXHR, textStatus, errorThrown) {
          $(".added-to-cart p.info-bar-link").text(
            "Something went wrong, try again"
          );
          $(".added-to-cart").addClass("show-add");
        },
      }
    );
  });

  $(document).on("cart.requestComplete", function (event, cart) {
    setTimeout(function () {
      $(".added-to-cart").removeClass("show-add");
    }, 2500);
  });

  $(document).ready(initialise);

  function initialise() {
    reviewsLoaded();
    reviewsSummary();
    reviewsFlex();
  }

  function reviewsFlex() {
    if ($(".junip-product-review-container").is(":visible")) {
      if (
        $(".junip-reviews-container.junip-reviews-layout-list").children()
          .length == 4
      ) {
        console.log("2 Children");
        setTimeout(function () {
          $(".junip-review-list-item-container").addClass("flex-child-50p");
        }, 500);
      } else {
      }
    } else {
      setTimeout(reviewsFlex, 50);
    }
  }

  function reviewsSummary() {
    if ($(".junip-product-review-container").is(":visible")) {
      const str = $(".junip-product-summary-star-ratings-container").text();
      const reviewCount = str.substring(
        str.lastIndexOf("(") + 1,
        str.lastIndexOf(")")
      );
      setTimeout(function () {
        $(".junip-product-summary-review-count")
          .addClass("loaded")
          .text(reviewCount + " Customer Reviews");
      }, 500);
    } else {
      setTimeout(reviewsSummary, 50);
    }
  }

  function reviewsLoaded() {
    if ($(".junip-product-review-container").is(":visible")) {
      const str = $(".junip-product-summary-review-count").text();
      const reviewCount = str.substring(
        str.lastIndexOf("(") + 1,
        str.lastIndexOf(")")
      );
      const productTitle = $(".product-info > h1.heading").text();
      $(".junip-product-review-title").text("Reviews of the " + productTitle);
      var authors = $(".junip-flex-wrapper");
      $(".junip-review-author").each(function (i) {
        authors.eq(i).append($(this));
      });
      $(".junip-review-title").each(function (i) {
        authors.eq(i).prepend($(this));
      });
      $(".junip-vote-text").text("Helpful?");
      $(".junip-vote-action:nth-child(2) .junip-vote-button").html(
        "<div>Yes</div>"
      );
      $(".junip-vote-action:nth-child(3) .junip-vote-button").html(
        "<div>No</div>"
      );
      $(
        '<button class="read-all-button junip-btn junip-btn-sm">Read all Reviews</button>'
      ).appendTo(".junip-write-review-cta-container");
      setTimeout(function () {
        $(".junip-product-review").clone().appendTo(".reviews-section");
        $(".reviews-section h3.cart-heading span").text(reviewCount);
      }, 200);
      $(".read-all-button").on("click", function () {
        readAllClick();
        $("button.junip-see-more").on("click", function () {
          setTimeout(function () {
            $(".reviews-section .junip-vote-text").text("Helpful?");
            $(
              ".reviews-section .junip-vote-action:nth-child(2) .junip-vote-button"
            ).html("<div>Yes</div>");
            $(
              ".reviews-section .junip-vote-action:nth-child(3) .junip-vote-button"
            ).html("<div>No</div>");
            var clonedAuthors = $(".reviews-wrapper .junip-flex-wrapper");
            $(".reviews-wrapper .junip-review-author").each(function (i) {
              clonedAuthors.eq(i).append($(this));
            });
            $(".reviews-wrapper .junip-review-title").each(function (i) {
              clonedAuthors.eq(i).prepend($(this));
            });
          }, 500);
        });
      });
      $("a.close-reviews").on("click", function () {
        $(".reviews-wrapper").removeClass("reveal");
      });
      var maxLength = 300;
      $(".junip-review-body").each(function () {
        var myStr = $(this).text();
        if ($.trim(myStr).length > maxLength) {
          var newStr = myStr.substring(0, maxLength);
          var removedStr = myStr.substring(maxLength, $.trim(myStr).length);
          $(this).empty().html(newStr);
          $(this).append(
            '<span class="dots">... </span><a href="javascript:void(0);" class="read-more"> Read more</a>'
          );
          $(this).append('<span class="more-text">' + removedStr + "</span>");
        }
      });
      $(".junip-review-body .read-more").click(function () {
        $(this).siblings(".more-text").contents().unwrap();
        $(this).siblings(".dots").remove();
        $(this).remove();
      });
      var isMobile = window.matchMedia("only screen and (max-width: 768px)");
      if (isMobile.matches) {
        $(".junip-write-review-cta-container")
          .addClass("show")
          .appendTo(".junip-product-review-container");
      }
    } else {
      setTimeout(reviewsLoaded, 50);
    }
  }
  function readAllClick() {
    $(".reviews-wrapper").addClass("reveal");
    $(".reviews-section .junip-vote-text").text("Helpful?");
    $(
      ".reviews-section .junip-vote-action:nth-child(2) .junip-vote-button"
    ).html("<div>Yes</div>");
    $(
      ".reviews-section .junip-vote-action:nth-child(3) .junip-vote-button"
    ).html("<div>No</div>");
    var clonedAuthors = $(".reviews-wrapper .junip-flex-wrapper");
    $(".reviews-wrapper .junip-review-author").each(function (i) {
      clonedAuthors.eq(i).append($(this));
    });
    $(".reviews-wrapper .junip-review-title").each(function (i) {
      clonedAuthors.eq(i).prepend($(this));
    });
    $(".reviews-section .junip-product-review-summary-container").appendTo(
      ".reviews-heading"
    );
  }

  function readMore() {
    console.log("Read More Clicked!");
    setTimeout(function () {
      $(".reviews-section .junip-vote-text").text("Helpful?");
      $(
        ".reviews-section .junip-vote-action:nth-child(2) .junip-vote-button"
      ).html("<div>Yes</div>");
      $(
        ".reviews-section .junip-vote-action:nth-child(3) .junip-vote-button"
      ).html("<div>No</div>");
      var clonedAuthors = $(".reviews-wrapper .junip-flex-wrapper");
      $(".reviews-wrapper .junip-review-author").each(function (i) {
        clonedAuthors.eq(i).append($(this));
      });
      $(".reviews-wrapper .junip-review-title").each(function (i) {
        clonedAuthors.eq(i).prepend($(this));
      });
    }, 1000);
  }
});
